import { render, staticRenderFns } from "./BlogHomeRtl.vue?vue&type=template&id=674d868e"
import script from "./BlogHomeRtl.vue?vue&type=script&lang=js"
export * from "./BlogHomeRtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports